import { server } from '../common/conf';
import ReconnectingWebSocket from 'reconnecting-websocket';
var Comm = /** @class */ (function () {
    function Comm() {
        var _this = this;
        this.id = 1;
        this.promises = {};
        // let url = 'ws://li952-11.members.linode.com/exporter/'
        var url = server
            .replace('http://', 'ws://')
            .replace('https://', 'wss://');
        if (url.indexOf('ws') != 0) {
            url = 'wss://' + window.location.host + url;
        }
        // console.log('Web socket url', url)
        var socket = (this.socket = new ReconnectingWebSocket(url + 'ws/map'));
        socket.onopen = function (e) {
            console.log('[ws] open');
        };
        socket.onmessage = function (event) {
            var msg = JSON.parse(event.data);
            if (msg.id && _this.promises[msg.id]) {
                var r = _this.promises[msg.id].resolver;
                delete _this.promises[msg.id];
                r(msg);
            }
        };
        socket.onclose = function (event) {
            if (event.wasClean) {
                console.log("[close] Connection closed cleanly, code=".concat(event.code, " reason=").concat(event.reason));
            }
            else {
                // e.g. server process killed or network down
                // event.code is usually 1006 in this case
                console.log('[close] Connection died');
            }
        };
        socket.onerror = function (error) {
            console.log("[error]", error);
        };
        setInterval(function () { return _this.pinger(); }, 20 * 1000);
    }
    Comm.prototype.send = function (msg) {
        var _this = this;
        var id = (msg.id = this.id++);
        this.promises[id] = {};
        this.promises[id].promise = new Promise(function (resolve) {
            _this.promises[id].resolver = resolve;
            _this.socket.send(JSON.stringify(msg));
        });
        return this.promises[id].promise;
    };
    Comm.prototype.pinger = function () {
        this.send({ request: 'ping' }).then(function (x) {
            console.log('got a pong');
        });
    };
    return Comm;
}());
export { Comm };
